import { format } from 'date-fns';
import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface ActivitySupplierRow {
  supplier_name: string;
  purchase_bills: number;
  qty_purchased: number;
  net_purchase: number;
  paid: number;
  outstanding: number;
  average_purchase: number;
  last_purchase_date: string;
}

export const activitySupplierColumns: ReportColumn<ActivitySupplierRow>[] = [
  { id: 'supplier_name', header: 'Supplier', accessorKey: 'supplier_name' },
  { id: 'purchase_bills', header: 'Purchase Bills', accessorKey: 'purchase_bills', align: 'right' },
  { id: 'qty_purchased', header: 'Qty Purchased', accessorKey: 'qty_purchased', align: 'right' },
  {
    id: 'net_purchase',
    header: 'Net Purchase',
    align: 'right',
    cell: (r) => `${formatMoney(r.net_purchase)}`,
    exportValue: (r) => r.net_purchase,
  },
  {
    id: 'paid',
    header: 'Paid',
    align: 'right',
    cell: (r) => `${formatMoney(r.paid)}`,
    exportValue: (r) => r.paid,
  },
  {
    id: 'outstanding',
    header: 'Outstanding',
    align: 'right',
    cell: (r) => `${formatMoney(r.outstanding)}`,
    exportValue: (r) => r.outstanding,
  },
  {
    id: 'average_purchase',
    header: 'Average Purchase',
    align: 'right',
    cell: (r) => `${formatMoney(r.average_purchase)}`,
    exportValue: (r) => r.average_purchase,
  },
  {
    id: 'last_purchase_date',
    header: 'Last Purchase Date',
    cell: (r) => (r.last_purchase_date ? format(new Date(r.last_purchase_date), 'd MMM yyyy') : ''),
    exportValue: (r) => r.last_purchase_date,
  },
];
